// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"35879204","455":"b45ef600","977":"ef415dd7"}[chunkId] + ".chunk.js";
};